import Tour, { buildTourSteps, Step } from 'hellospa/components/tour';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isTourActive } from 'hellospa/app-context/actions/tours';

export const signatureRequestsTourName = 'signature-requests';

function SignatureRequestsTour() {

  const steps = React.useMemo(() => {
    const _steps: Step[] = [];

    _steps.push({
      tourItem: SignatureRequestsTour.steps.intro,
      placement: 'right',
      disableAdvanceOnTargetClick: true,
      variant: 'rich',
      title: (
        <FormattedMessage
          id=""
          description="Header text for a hint popup noting that the name of something on the site has changed."
          defaultMessage="New name" />
      ),
      content: (
        <FormattedMessage
          id=""
          description="Text for a hint popup noting that the name of something on the site has changed."
          defaultMessage="The <strong>Documents</strong> section is now called <strong>Signature requests</strong>."
          values={{
            // eslint-disable-next-line react/display-name
            strong: (...chunks: any[]) => <strong>{chunks}</strong>,
          }} />
      ),
      cta: (
        <FormattedMessage
          id=""
          description="Text for a button which will close the popup when clicked."
          defaultMessage="Got it" />
      ),
    });

    return _steps;
  }, []);

  if (!isTourActive(signatureRequestsTourName)) return null;

  return <Tour steps={steps} tourName={signatureRequestsTourName} />;
}

/**
 * If you just use `data-tour-item="mobile-fields"` it would work just fine, but
 * it may not be clear why it's there. With
 * `data-tour-item={MobileSignatureRequestsTour.Steps.MobileFieldControls}` you can follow
 * the import.
 */
SignatureRequestsTour.steps = buildTourSteps(signatureRequestsTourName, [
  'intro',
]);

export default SignatureRequestsTour;
